module.exports = __webpack_public_path__ + "static/media/null_icon.3d957dd9.svg";